module.exports = __webpack_public_path__ + "static/media/landing.5c6098af.jpg";